export const horus_espirito_santo = {
  // horusUrl: 'http://44.244.110.249:4200',
  // horusLogin: 'http://34.213.165.3:4300',
  horusUrl: 'https://horus.appvelsis.com',
  horusSerraGauchaUrl: 'https://horus-serra.appvelsis.com',
  horusLogin: 'https://horus-api.appvelsis.com',
  contractId: 11,
  user_horus: 'willian.betim@velsis.com.br',
  pass_horus: 'Pglwjpxt19!',
}

export const horus_serra_gaucha = {
  // horusUrl: 'http://44.244.110.249:4200',
  // horusLogin: 'http://34.213.165.3:4300',
  horusUrl: 'https://horus-serra.appvelsis.com',
  horusLogin: 'https://horus-serra-api.appvelsis.com',
  contractId: 20,
  user_horus: 'willian.betim@velsis.com.br',
  pass_horus: 'Pglwjpxt19!',
}

export const horus_via_araucaria = {
  // horusUrl: 'http://44.244.110.249:4200',
  // horusLogin: 'http://34.213.165.3:4300',
  horusUrl: 'https://horus-viaaraucaria.appvelsis.com',
  horusLogin: 'https://horus-viaaraucaria-api.appvelsis.com',
  contractId: 4,
  user_horus: 'willian.betim@velsis.com.br',
  pass_horus: 'Pglwjpxt19!',
}

export const environment = {
  moduleId: 2,
  production: true,
  apiUrl: 'https://dev-nexus.appvelsis.com',
  accountLoginApiUrl: 'https://dev-nexus.appvelsis.com/',
  googleMapsKey: 'AIzaSyDk1O2udZedUxNsZQOsfSGkgnZ1MC581Bs',
  baseApiImage: 'https://dev-nexus.appvelsis.com/external/api/s3?region=us-west-2&bucket=falcon-processamento-trafego-prd&objectId=',
  webSocketURL: 'https://dev-nexus.appvelsis.com/alert-persistence/subscribe',
  webSocketURLSerraGaucha: 'https://dev-nexus.appvelsis.com/alert-persistence-serra-gaucha/subscribe',

  apiReports: "https://relatorio-serra-api.appvelsis.com/",
  apiReportsProxy: "https://dev-nexus.appvelsis.com/",


  framework: 'framework-akamai.appvelsis.com',
  horus_serra_gaucha: horus_serra_gaucha,
  horus_espirito_santo: horus_espirito_santo,
  horus_via_araucaria: horus_via_araucaria,

  version: 'v1.1.777 D',

};
